import template from './creditworthinessCard.html';
import './creditworthinessCard.scss';

let creditworthinessCardComponent = {
  restrict: 'E',
  bindings: {
    information: '<'
  },
  template
};
export default creditworthinessCardComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessCard/creditworthinessCard.component.js